"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsHomemadeModalConnection = exports.getIsHomemadeExternalConnection = exports.getIsHomemadeIframeConnection = exports.getIsStandardConnection = void 0;

var ConnectionType = _interopRequireWildcard(require("../constants/ConnectionType"));

var getIsStandardConnection = function getIsStandardConnection(connectionType) {
  return connectionType === ConnectionType.STANDARD;
};

exports.getIsStandardConnection = getIsStandardConnection;

var getIsHomemadeIframeConnection = function getIsHomemadeIframeConnection(connectionType) {
  return connectionType === ConnectionType.HOMEMADE_IFRAME;
};

exports.getIsHomemadeIframeConnection = getIsHomemadeIframeConnection;

var getIsHomemadeExternalConnection = function getIsHomemadeExternalConnection(connectionType) {
  return connectionType === ConnectionType.HOMEMADE_EXTERNAL;
};

exports.getIsHomemadeExternalConnection = getIsHomemadeExternalConnection;

var getIsHomemadeModalConnection = function getIsHomemadeModalConnection(connectionType) {
  return connectionType === ConnectionType.HOMEMADE_MODAL;
};

exports.getIsHomemadeModalConnection = getIsHomemadeModalConnection;


//////////////////
// WEBPACK FOOTER
// ./js/utils/offerings.js
// module id = 392
// module chunks = 209 210 211 212